import { render, staticRenderFns } from "./MiraSolutionsLogo.vue?vue&type=template&id=13be12ff&scoped=true"
import script from "./MiraSolutionsLogo.vue?vue&type=script&lang=js"
export * from "./MiraSolutionsLogo.vue?vue&type=script&lang=js"
import style0 from "./MiraSolutionsLogo.vue?vue&type=style&index=0&id=13be12ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be12ff",
  null
  
)

export default component.exports